import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit, HostListener, ViewChildren, QueryList } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { fromEvent, Subscription } from 'rxjs';
import { Wizard, wizardConfig } from "src/app/_models/common/wizard";


@Component({
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    standalone: false
})
export class WizardComponent implements OnInit, AfterViewInit {
  @ViewChild('wizardDiv', { read: ElementRef }) wizardDivElement: ElementRef<any>;
  @Output() StepClickEvent = new EventEmitter<any>();
  @Output() OnScroll = new EventEmitter<any>();
  @Output() openGoogleInvoicesEvent = new EventEmitter<any>();

  param: string;
  @Input() wizardDetails: Wizard[] = [];
  @Input() wizardConfig: wizardConfig;
  @Input() isEssential: boolean;
  // When true, the first-load "step extra message" box is hidden (e.g. during
  // Self-Setup, where the guided tour already covers the step to avoid overlap).
  @Input() hideExtraMessage: boolean = false;
  divClass: string;
  resizeSubscription$: Subscription;
  isFirstLoad: boolean;
  

  constructor(private sanitizer: DomSanitizer) {
    this.isFirstLoad = true;
  }

  ngOnInit() {
    const resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = resizeObservable$.subscribe(evt => {
      this.setWidthAndHeight();
    });
    if(this.isEssential == null)
    {
      this.isEssential=false;
    }
    //default scroll step
    if(this.wizardConfig?.defaultScrollId > 1){
      setTimeout(() => {
        let el = document.getElementById(this.wizardConfig.defaultScrollId.toString());
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 600);   
    }

  }

  @ViewChild('testDiv', { static: false })
  private testDiv: ElementRef<HTMLDivElement>;
  isTestDivScrolledIntoView: boolean;
  @ViewChildren("stepsDiv") private stepsDivs: QueryList<ElementRef>;



  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScrollDiv(event) {

    for (let index = 0; index < this.stepsDivs?.length; index++) {
      const rect = this.stepsDivs.toArray()[index].nativeElement.getBoundingClientRect();
      const topShown = rect.top >= 0;
      const bottomShown = rect.bottom <= window.innerHeight;
      this.isTestDivScrolledIntoView = topShown && bottomShown;

      if (this.isTestDivScrolledIntoView) {
        this.OnScroll.emit(index + 1);
      }

    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setWidthAndHeight();
      this.onScrollDiv('');
    }, 200);


  }

  public setWidthAndHeight() {
    setTimeout(() => {
      const searchRowRect = this.wizardDivElement.nativeElement.getBoundingClientRect();
      if (this.wizardConfig && this.wizardConfig.mainScrollConditionRequired) {
        if (window.innerHeight < searchRowRect.bottom) {
          this.divClass = "overflow-auto scrollbar-visible heightCalc-5";

        }
        else {
          this.divClass = '';
        }
      }
      else {
        this.divClass = "overflow-auto scrollbar-visible heightCalc-10";
      }



    }, 100);
  }
  navigateToStep(stepData: any) {    

    if (stepData.stepNum >= 5) {
      setTimeout(() => {
        this.stepsDivs.toArray()[this.stepsDivs.length-1].nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 500 );
      
    }
    this.StepClickEvent.emit(stepData);
  }

  sanitizerHtml(element) {
    if (element) {
      let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
      return safeText;
    }
    else {
      return '&nbsp';
    }

  }
  fnCloseMessage(item: Wizard, e: Event) {
    e.stopPropagation();
    this.isFirstLoad = false;
    let step = this.wizardDetails.find(a => a.stepNum == item.stepNum);
    if (step) {
      step.stepExtraMessage = '';
    }
  }

  onButtonClick(event) { 
    event.stopPropagation();
    this.openGoogleInvoicesEvent.emit();
  }

}
